import React from 'react';
import TextAdapter from './TextAdapter';
import { AdapterProps } from '../types';

const NumberAdapter = (props: AdapterProps['number']) => (
  <TextAdapter type="number" {...props} />
);

export default NumberAdapter;
